import React from "react";
import "./FormHeader.css";
import Search from "./Search";
import WestIcon from '@mui/icons-material/West';
import SearchV2 from "./SearchV2";

interface FormHeaderProps {
  parentLabel: string;
  label: string;
  searchFunction?: (value: string) => void;
  goBackToParent: () => void;
  childLabel?: string;
  childLableCaseClick?: () => void;
  label1Click?: () => void;
  childLabel2?: string;
  childLabel3?: string;
  backButtonClick?: () => void;
  Component?: React.ReactNode; 
  insideManageOrder?: boolean
}

const FormHeader: React.FC<FormHeaderProps> = ({
  parentLabel,
  label,
  searchFunction,
  goBackToParent,
  childLabel,
  label1Click,
  childLableCaseClick,
  childLabel2,
  childLabel3,
  backButtonClick,
  Component,
  insideManageOrder=false
  
}) => {

  const handleWestIconClick = () => {
    if(backButtonClick){
      backButtonClick();
    }
    else if(label1Click) {
      label1Click();
    } else {
      goBackToParent();
    }
  };
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {
    manageSecondaryOrderV2,
  } = ConfigDictionary;
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <div className="FormHeader">
        <WestIcon sx={{ fontSize: 20, color: "#444444", marginTop: "-1px", cursor: "pointer" }} onClick={() => handleWestIconClick()} />
        <span className="FormHeader_parent_text"  onClick={() => childLableCaseClick ? childLableCaseClick() : goBackToParent()}>
          {parentLabel}
        </span>
        &gt;
        <span
          className={childLabel ? "FormHeader_parent_text" : "FormHeader_current"}
          onClick={() => (label1Click ? label1Click() : goBackToParent())}
        >
          {label}
        </span>
        {childLabel && (
          <>
            &gt;
            <span
              className={
                !childLabel2 ? "FormHeader_current" : "FormHeader_parent_text"
              }
              onClick={childLabel ? () => goBackToParent() : undefined}
            >
              {childLabel}
            </span>
          </>
        )}
        {childLabel2 && (
          <>
            &gt;
            <span
              onClick={childLabel ? () => goBackToParent() : undefined}
              className={
                !childLabel3 ? "FormHeader_current" : "FormHeader_parent_text"
              }
            >
              {childLabel2}
            </span>
          </>
        )}
        {childLabel3 && (
          <>
            &gt;
            <span
              onClick={childLabel ? () => goBackToParent() : undefined}
              className={
                childLabel3 ? "FormHeader_current" : "FormHeader_parent_text"
              }
            >
              {childLabel3}
            </span>
          </>
        )}
      </div>

      <div className="form-header-components">
        {Component && (
          <div className="form-header-filter">
            {Component}
          </div>
        )}
        {searchFunction && (
          <div className="searchWidth">
            {(manageSecondaryOrderV2 && insideManageOrder) ? <SearchV2 searchFunction={searchFunction}/> : <Search searchFunction={searchFunction} />}
          </div>
        )}
      </div>  
    </div>
  );
};

export default FormHeader;
